export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10169.388082ce.jpg";